// extracted by mini-css-extract-plugin
export default {"modalLogout":"styles-scoped__modalLogout--vt0Ww","actionContainerLogout":"styles-scoped__actionContainerLogout--Ux1yE"};